/**
 * Public pages that do not require authentication.
 * These pages are accessible without a valid session.
 */
export const PUBLIC_PAGE_PATHS = [
  '/404',
  '/signin',
  '/docs',
  '/docs/dropship-api',
  '/docs/getting-started',
];

/**
 * Checks if a given pathname is a public page (does not require authentication).
 */
export function isPublicPage(pathname: string): boolean {
  return PUBLIC_PAGE_PATHS.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/'),
  );
}
